<template>
  <div class="modelling-left-panel">
    <div class="modelling-left-panel__header">
      <div class="modelling-left-panel__icon" />
      <div class="modelling-left-panel__title">
        Моделирование
      </div>
    </div>
    <slot></slot>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss">
.modelling-left-panel {
  height: 100%;
  width: 250px;
  box-shadow: 2px 0 10px 0px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  background-color: var(--text_secondary) !important;

  &__header {
    padding: 10px;
    display: flex;
    align-items: center;
    color: #fff;
    background-color: var(--modal_bg) !important;
  }
  &__icon {
    width: 24px;
    height: 24px;
    background-size: 100%;
    background-repeat: no-repeat;
    background-position: 50%;
    background-image: url("../../../assets/images/navbar/modelling.svg");
    margin-right: 10px;
  }
  &__title {
    font-size: 14px;
    font-weight: bold;
  }
}
</style>
